// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    organizationId: z.string().min(1).max(21),
    departmentId: z.string().min(1).max(21),
    userId: z.string().min(1).max(128),
    source: z.string().min(1).max(16),
});
const guard = z.object({
    tenantId: z.string().max(21),
    organizationId: z.string().min(1).max(21),
    departmentId: z.string().min(1).max(21),
    userId: z.string().min(1).max(128),
    source: z.string().min(1).max(16),
});
export const OrganizationDepartmentLeaders = Object.freeze({
    table: 'organization_department_leaders',
    tableSingular: 'organization_department_leader',
    fields: {
        tenantId: 'tenant_id',
        organizationId: 'organization_id',
        departmentId: 'department_id',
        userId: 'user_id',
        source: 'source',
    },
    fieldKeys: [
        'tenantId',
        'organizationId',
        'departmentId',
        'userId',
        'source',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
